import { create } from 'zustand';

export const useSplashScreenStore = create<{
  isShowSplashScreen: boolean;
  setIsShowSplashScreen: (isShowSplashScreen: boolean) => void;
}>((set) => ({
  isShowSplashScreen: true,
  setIsShowSplashScreen: (isShowSplashScreen: boolean) => {
    set({ isShowSplashScreen });
  },
}));
